import myModal from '@/components/common/modal/index.vue'
import scroll from '@/utils/noscroll.js';
import index from './index.vue';

import { createApp } from 'vue';
let loadingInstance = null;
let activeRequests = 0;
let loadingTimeout = null;
let minLoadingTime = 0; // 最少显示时间为 2 秒
let app = null;
let div = null;

const showLoading = () => {
  console.log('showLoading',activeRequests,app);
  if (activeRequests === 0 && !app) {
    console.log('0activeRequests:',activeRequests);
     div = document.createElement('div');
    document.body.appendChild(div);
     app = createApp(index, {
      visible: true,
      'onUpdate:visible': (value) => {
        console.log('closeLoading', value);
        hideLoading();
      },
      'onClosed':(value)=>{
        console.log('关闭加载loading框');
        console.log('closeLoading', value);
        hideLoading();
      }
    });
    app.provide('scroll', scroll)
    app.component('myModal', myModal);
    app.mount(div);
  }
  activeRequests++;
};

const hideLoading = () => {
  console.log('activeRequests:', activeRequests);
  if(activeRequests > 0){
    activeRequests--;
  }
  console.log('hideLoading');
  if (activeRequests === 0 && app) {
    // 如果定时器已经存在，清除它
    if (loadingTimeout) {
      clearTimeout(loadingTimeout);
    }
    // 设置新的定时器
    loadingTimeout = setTimeout(() => {
      console.log('hideLoading timeout', loadingTimeout);
      console.log('定时器');
      app.unmount();
      app = null;
      div.remove()

    }, minLoadingTime);
  }
};

export { showLoading, hideLoading };
